export const verificationGermanLocalization = {
  sheets: {
    verifyMail: {
      title: 'Bitte bestätige erst deine E-Mail-Adresse',
      text: 'Wir haben nach deiner Anmeldung eine Anleitung an <email /> geschickt. Nichts bekommen? Einfach nochmal senden!',
      resend: 'E-Mail erneut schicken',
      help: 'Hilfe benötigt?'
    },
    successMail: {
      title: 'Vielen Dank!',
      text: 'Deine E-Mail-Adresse wurde bestätigt.\nViel Spaß beim Funken!',
      confirm: 'Alles klar'
    }
  }
};

// Guarantees that both translations have the same structure
type Locales = typeof verificationGermanLocalization;

export const verificationEnglishLocalization: Locales = {
  sheets: {
    verifyMail: {
      title: 'Please first confirm your email address',
      text: 'We sent an email to <email /> during registration. If you did not receive it, you can resend it.',
      resend: 'Resend email',
      help: 'Help needed?'
    },
    successMail: {
      title: 'Thank you!',
      text: 'Your email address has been confirmed. Have fun transmitting!',
      confirm: 'OK'
    }
  }
};
